// @core/api/endpoints/resource/refresh_external_resource.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ExternalResourceResponse,
  RefreshExternalResourceRequest,
} from '../../../types/resource';

const BASE_PATH = '/resource';

/**
 * Refresh external resource metadata
 * Re-fetches metadata from the external URL to update the resource's title, description, and other properties. Useful when the external page has changed.
 */
export async function RefreshExternalResource(
  resource_id: string,
  data: RefreshExternalResourceRequest,
  options?: RequestOptions
): Promise<ExternalResourceResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/resources/external/:resource_id/refresh`;
  requestPath = requestPath.replace(':resource_id', encodeURIComponent(resource_id));
  const requestOptions = options;
  return client.post<ExternalResourceResponse>(requestPath, data, requestOptions);
}
